import { useMemo } from 'react';
import { Order } from '@components/framework/orders/common';

export interface ExternalOrdersDateRange {
  externalOrdersMinDate: Date | undefined;
  externalOrdersMaxDate: Date | undefined;
  externalOrdersMinIso: string | undefined;
}

export const useExternalOrdersDateRange = (orders: Order[] | undefined): ExternalOrdersDateRange => {
  return useMemo(() => {
    let min: number | null = null;
    let max: number | null = null;
    let minIso: string | null = null;
    orders?.forEach(order => {
      order.externalOrders?.forEach(eo => {
        if (eo.timeFrom) {
          const fromMs = new Date(eo.timeFrom).getTime();
          if (!Number.isNaN(fromMs) && (min === null || fromMs > min)) {
            min = fromMs;
            minIso = eo.timeFrom;
          }
        }
        if (eo.timeTo) {
          const toMs = new Date(eo.timeTo).getTime();
          if (!Number.isNaN(toMs) && (max === null || toMs < max)) max = toMs;
        }
      });
    });
    return {
      externalOrdersMinDate: min !== null ? new Date(min) : undefined,
      externalOrdersMaxDate: max !== null ? new Date(max) : undefined,
      externalOrdersMinIso: minIso ?? undefined,
    };
  }, [orders]);
};